import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "container" }

import {nextTick, onMounted, reactive, ref} from "vue";
import {message} from "ant-design-vue";
import {getRenewDetails, pageListRenew, saveOrUpdate, toggleShelves} from "@/api/sysRenewAndriod";
import UploadFile2 from "@/components/view/UploadFile2.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

let docValidator = () => {
    if (addOrUpdateForm.docBo.path) {
        return Promise.resolve();
    } else {
        return Promise.reject("请上传APP安装包!");
    }
};


const columns = [
    {
        title: "序号",
        dataIndex: "key",
        key: "key",
        customRender: ({ index }: any) => `${index + 1}`,
    },
    {
        title: "版本",
        dataIndex: "renewVersion",
        key: "renewVersion",
    },
    {
        title: "类型",
        dataIndex: "renewType",
        key: "renewType",
    },
    {
        title: "更新说明",
        dataIndex: "comment",
        key: "comment",
        width:350
    },
    {
        title: "是否上架",
        dataIndex: "isShelves",
        key: "isShelves",
    },
    {
        title: "操作",
        dataIndex: "operation",
        key: "operation",
    },
];



const data = reactive({
    loading: false,
    visible: false,
    btn: '点击上传APP安装包',
    fileList:[{
        uid:'',
        url:'',
        name:"",
        status:'done'
    }],
    comments: "",
    keyword: "",
    fileName: '',
    dataOptions: [],
    pagination: {
        size: "small",
        current: 1,
        pageSize: 10,
        total: 0,
        pageSizeOptions: ["10", "20", "30"],
        showTotal: (total: string) => {
            return " 共" + total + "条";
        },
        hideOnSinglePage: false,
        showSizeChanger: true,
    },
    formVisible: false,
    title: '新增服务项',
    labelCol: { style: { width: '120px' } },
    wrapperCol: { span: 20 },
    rules: {
        renewVersion:[
            {
                required: true,
                trigger: "change",
            }
        ],
        renewType:[
            {
                required: true,
                trigger: "change",
            }
        ],
        comment:[
            {
                required: true,
                trigger: "change",
            }
        ],
        isShelves:[
            {
                required: true,
                trigger: "change",
            }
        ],
        docBo:[
            { validator: docValidator, trigger: "blur",required: true },
        ],

    }
})

const addOrUpdateForm = reactive({
    id: "",
    renewVersion: "",
    renewType: "MANDATORY",
    comment: "",
    isShelves: false,
    docBo: {
        title: "APP更新",
        path: "",
        type: "APP_URL",
        id: ''
    },

})

const search = ()=>{
    let option = {
        keyword: data.keyword,
        page: {
            pageSize: data.pagination.pageSize,
            currPage: data.pagination.current,
        }
    }
    data.loading = true
    pageListRenew(option).then((res: any)=>{
        data.dataOptions = res && res.data?res.data:[];
        data.pagination.total = res.records;
        data.loading = false
    })
}

const changePageIndex = (page: any) => {
    data.pagination.pageSize = page.pageSize;
    data.pagination.current = page.current;
    search();
};

const searchKeyword = () => {
    data.pagination.current = 1
    search();
}

const toggleStatus = (id: string) => {
    toggleShelves(id).then(()=>{
        search()
    })
};
const createRenewRef = ref();
const toAddOrUpdate = (type: number,id: string) =>{
    if(type === 1){
        data.title = '新增更新';
        data.fileList = [];
        const timestamp: number = Date.parse(new Date());
        data.fileName = "/renew/"+timestamp+"/mashangkanya.apk"
        data.formVisible=true;
        nextTick(()=>{
            addOrUpdateForm.id = '';
            createRenewRef.value?.resetFields();
        })
    }else if(type === 2){
        getRenewDetails(id).then((res: any)=>{
            data.title = '修改更新';
            data.fileList=[{
                uid:res.docBo.id,
                url:res.docBo.path,
                name:"马上看牙.apk",
                status:'done'
            }]
            console.log("当前的附件:",data.fileList)
            data.formVisible=true;
            nextTick(()=>{
                createRenewRef.value?.resetFields();
                addOrUpdateForm.id = id;
                addOrUpdateForm.renewVersion = res.renewVersion;
                addOrUpdateForm.renewType = res.renewType;
                addOrUpdateForm.comment = res.comment;
                addOrUpdateForm.isShelves = res.isShelves;
                addOrUpdateForm.docBo = {
                    title: "APP更新",
                    path: res.docBo.path,
                    type: res.docBo.type,
                    id: res.docBo.id
                }
            })
            data.fileName = "/renew/"+ res.docBo.path.split("/renew/")[1]
        })
    }
}
const toComments = (comments: string)=>{
    data.comments = comments;
    data.visible = true;
}
const onSuccess = (val: string) => {
    data.btn = "点击上传APP安装包"
    addOrUpdateForm.docBo.path = val;
    createRenewRef.value.validate("docBo")
};

const beforeUpload = () => {
    data.btn = "上传中，请稍后..."
};
const onRemove = () => {
    addOrUpdateForm.docBo.path = '';
    createRenewRef.value.validate("docBo")
}
const onCancel = () =>{
    createRenewRef.value?.resetFields();
    data.formVisible = false;
}
const onAddOrUpdate = () =>{
    createRenewRef.value.validate().then(() => {
        data.loading = true
        saveOrUpdate(addOrUpdateForm).then(()=>{
            message.success("操作成功");
            data.formVisible = false;
            search();
            data.loading = false
        })
    })
}
onMounted(()=>{
    search()
})


return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_switch = _resolveComponent("a-switch")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_card, null, {
      default: _withCtx(() => [
        _createVNode(_component_a_row, { gutter: 20 }, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, { span: 6 }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: data.keyword,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((data.keyword) = $event)),
                  placeholder: "关键字",
                  onChange: searchKeyword,
                  "allow-clear": ""
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_col, { span: 2 }, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, {
                  type: "primary",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (toAddOrUpdate(1,'')))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("新增")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_a_table, {
      dataSource: data.dataOptions,
      columns: columns,
      loading: data.loading,
      pagination: data.pagination,
      onChange: changePageIndex
    }, {
      bodyCell: _withCtx(({ column, record }) => [
        (column.dataIndex === 'renewType')
          ? (_openBlock(), _createBlock(_component_a_tag, {
              key: 0,
              color: record.renewType==='MANDATORY'?'success':'default'
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(record.renewType==='MANDATORY'?'强制更新':'非强制更新'), 1)
              ]),
              _: 2
            }, 1032, ["color"]))
          : _createCommentVNode("", true),
        (column.dataIndex === 'comment')
          ? (_openBlock(), _createBlock(_component_a_button, {
              key: 1,
              style: {"margin-right":"5px"},
              type: "link",
              onClick: ($event: any) => (toComments(record.comment))
            }, {
              default: _withCtx(() => [
                _createTextVNode("查看")
              ]),
              _: 2
            }, 1032, ["onClick"]))
          : _createCommentVNode("", true),
        (column.dataIndex === 'isShelves')
          ? (_openBlock(), _createBlock(_component_a_switch, {
              key: 2,
              "checked-children": "是",
              onClick: ($event: any) => (toggleStatus(record.id)),
              "un-checked-children": "否",
              checked: record.isShelves,
              "onUpdate:checked": ($event: any) => ((record.isShelves) = $event)
            }, null, 8, ["onClick", "checked", "onUpdate:checked"]))
          : _createCommentVNode("", true),
        (column.dataIndex === 'operation')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
              _createVNode(_component_a_button, {
                style: {"margin-right":"5px"},
                type: "primary",
                onClick: ($event: any) => (toAddOrUpdate(2,record.id))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("修改")
                ]),
                _: 2
              }, 1032, ["onClick"]),
              _createVNode(_component_a_button, {
                style: {"margin-right":"5px"},
                type: "primary",
                onClick: ($event: any) => (toComments(record.docBo.path))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("链接")
                ]),
                _: 2
              }, 1032, ["onClick"])
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["dataSource", "loading", "pagination"]),
    _createVNode(_component_a_modal, {
      visible: data.formVisible,
      "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => ((data.formVisible) = $event)),
      title: data.title,
      width: "40%",
      onClose: onCancel,
      onOk: onAddOrUpdate
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          model: addOrUpdateForm,
          "label-col": data.labelCol,
          "wrapper-col": data.wrapperCol,
          autoComplete: "off",
          rules: data.rules,
          ref_key: "createRenewRef",
          ref: createRenewRef
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_row, { gutter: 24 }, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, {
                      label: "更新版本",
                      name: "renewVersion"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          value: addOrUpdateForm.renewVersion,
                          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((addOrUpdateForm.renewVersion) = $event))
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_row, { gutter: 24 }, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, {
                      label: "安装包",
                      name: "docBo"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(UploadFile2, {
                          onOnSuccess: onSuccess,
                          onOnRemove: onRemove,
                          accept: ".apk",
                          onBeforeUpload: beforeUpload,
                          "file-list": data.fileList,
                          fileName: "马上看牙.apk",
                          path: data.fileName,
                          "bn-title": data.btn
                        }, null, 8, ["file-list", "path", "bn-title"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_row, { gutter: 24 }, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, {
                      label: "是否强制更新",
                      name: "renewType"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_select, {
                          ref: "select",
                          value: addOrUpdateForm.renewType,
                          "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((addOrUpdateForm.renewType) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_select_option, { value: "MANDATORY" }, {
                              default: _withCtx(() => [
                                _createTextVNode("强制更新")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_select_option, { value: "UN_MANDATORY" }, {
                              default: _withCtx(() => [
                                _createTextVNode("非强制更新")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_row, { gutter: 24 }, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, {
                      label: "更新说明",
                      name: "comment"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_textarea, {
                          value: addOrUpdateForm.comment,
                          "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((addOrUpdateForm.comment) = $event)),
                          placeholder: "请输入描述",
                          rows: 4
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_row, { gutter: 24 }, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, {
                      label: "是否上架",
                      name: "isShelves"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_switch, {
                          "checked-children": "是",
                          "un-checked-children": "否",
                          checked: addOrUpdateForm.isShelves,
                          "onUpdate:checked": _cache[5] || (_cache[5] = ($event: any) => ((addOrUpdateForm.isShelves) = $event))
                        }, null, 8, ["checked"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "label-col", "wrapper-col", "rules"])
      ]),
      _: 1
    }, 8, ["visible", "title"]),
    _createVNode(_component_a_modal, {
      visible: data.visible,
      "onUpdate:visible": _cache[7] || (_cache[7] = ($event: any) => ((data.visible) = $event)),
      onOk: _cache[8] || (_cache[8] = ()=>{data.visible = false})
    }, {
      default: _withCtx(() => [
        _createElementVNode("p", null, _toDisplayString(data.comments), 1)
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}
}

})